import { BusinessObjectBase, JoinPoint, JoinPointContext, ModelBase } from '@skylab-shared/core';

type Handler = (ctx: RecalculateDocumentJoinPointContext) => void;

export class RecalculateDocumentJoinPoint extends JoinPoint<RecalculateDocumentJoinPointContext> { }

export class RecalculateDocumentJoinPointContext extends JoinPointContext {
    public constructor(
        sender: BusinessObjectBase<ModelBase>
    ) {
        super(sender);
    }
}

export const recalculateDocumentJoinPointFilter = (sender: any) => <TModel extends ModelBase>() => (handler: Handler): Handler => {
    return (ctx: RecalculateDocumentJoinPointContext): void => {
        if (ctx.sender === sender) {
            handler(ctx);
        }
    };
};

type RecalculatedHandler = (ctx: DocumentRecalculatedJoinPointContext) => void;

export class DocumentRecalculatedJoinPoint extends JoinPoint<DocumentRecalculatedJoinPointContext> { }

export class DocumentRecalculatedJoinPointContext extends JoinPointContext {
    public constructor(
        sender: BusinessObjectBase<ModelBase>
    ) {
        super(sender);
    }
}

export const documentRecalculatedJoinPointFilter = (sender: any) => <TModel extends ModelBase>() => (handler: RecalculatedHandler): RecalculatedHandler => {
    return (ctx: DocumentRecalculatedJoinPointContext): void => {
        if (ctx.sender === sender) {
            handler(ctx);
        }
    };
};

type RecalculatedItemHandler = (ctx: DocumentItemRecalculatedJoinPointContext) => void;

export class DocumentItemRecalculatedJoinPoint extends JoinPoint<DocumentItemRecalculatedJoinPointContext> { }

export class DocumentItemRecalculatedJoinPointContext extends JoinPointContext {
    public constructor(
        sender: ModelBase
    ) {
        super(sender);
    }
}

export const documentItemRecalculatedJoinPointFilter = (sender: any) => <TModel extends ModelBase>() => (handler: RecalculatedItemHandler): RecalculatedItemHandler => {
    return (ctx: DocumentItemRecalculatedJoinPointContext): void => {
        if (ctx.sender === sender) {
            handler(ctx);
        }
    };
};
